/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

export function animateLeave(el: HTMLElement): Promise<void> {
  return new Promise((resolve) => {
    el.addEventListener('animationend', () => {
      resolve()
      el.classList.remove('leave')
    }, { once: true })

    el.classList.add('leave')
  })
}

export function prepareLeave(el: HTMLElement) {
  el.classList.add('leave')
}

export function animateEnter(el: HTMLElement): Promise<void> {
  return new Promise((resolve) => {
    el.addEventListener('animationend', () => {
      resolve()
      el.classList.remove('enter')
    }, { once: true })

    el.classList.add('enter')
  })
}

export function prepareEnter(el: HTMLElement) {
  el.classList.add('enter')
}
